<template>
    <div class="questionBoxWrap">
      <div class="questionBox">
        <div class="paperAirPlaneWrap">
          <div class="paperAirPlane">
          </div>
        </div>

        <div class="questionBoxComment">
          <p>
            제작문의 및 견적을 의뢰하시면 신속하게 답변드립니다.<br/>
            빠른 상담을 원하시는 분은 이메일로 문의 주시기 바랍니다.
          </p>
        </div>

        <div class="questionBoxMail">
          <span class="mailPostImage"></span>
          <span class="mailAddress">seun80@hanmail.net</span>
        </div>

      </div>
    </div>
</template>

<script>
    export default {
        name: "question-box"
    }
</script>

<style scoped lang="scss">
  @import "@/styles/ContactUs.scss";
  .questionBoxWrap{
    width:100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top:4rem;
    .questionBox{
      width:45%;
      background:#fff;
      height:210px;

      .paperAirPlaneWrap{
        width:100%;
        height:30%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top:1rem;
        >.paperAirPlane {
          width: 63px;
          height: 44px;
          background: url(//d77k7si2heyyr.cloudfront.net/images/icons/paper-airplane.png)
        }

      }

      .questionBoxComment{
        text-align: center;
        color:#666;
      }

      .questionBoxMail{
        display: flex;
        align-items: center;
        justify-content: center;
        .mailPostImage{
          width:26px;
          height:19px;
          display: inline-block;
          background: url(//d77k7si2heyyr.cloudfront.net/images/icons/post.png);
          margin-right:0.6rem;
        }
        .mailAddress{
          color:#666;
        }

      }


    }
  }


</style>



// WEBPACK FOOTER //
// src/components/menu/ContactUs/QuestionBox.vue